

















































































































































































































































































































































































































































































































































































































import { PageModule } from "@/store/module/page";
import {
  getWaitingStudentListData,
  getWaitingStudentListApi,
  exportWaitingStudentListApi,
  claimWaitingStudentApi,
} from "@/api/studentManage";
import {
  getStudentAppearListApi,
  sourceTypeSelectListApi,
} from "@/api/storeManagement";
import eventBus from "@/utils/bus";
import mutiEditDialog from "../latent/mutiEditDialog.vue";
import { dateFormat } from "@/utils/timeFormat";
import { Vue, Component } from "vue-property-decorator";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
import { getFollowLatentApi } from "@/api/studentFollow";
import { staffList } from "@/api/globalSearch";
import { getMarketStaffListApi } from "@/api/marketActivity";
import { exportLoop } from "@/utils/export";
import { UserModule } from "@/store/module/user";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

@Component({
  name: "waitingStudent",
  components: {
    mutiEditDialog,
    commonStaffPullDown,
    commonSearchFormWrapper,
    commonDateRangeSelector,
  },
})
export default class extends Vue {
  showFormSearch = false;
  searchInfo: any = {
    key_word: "",
    sex: "",
    allocate_num_start: "",
    allocate_num_end: "",
    allocate_time: [],
    follow_time: [],
    appear_id: "",
    source_type: "",
    last_follow_staff_id: "",
    date: [],
    intent_arr: [],
    age_stage: "",
    follow_status: [],
    market_staff_id: "",
    create_staff_id: "",
  };
  sourceList: any[] = [];
  tableData: any[] = [];
  multipleSelection: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  pageSizeArray: number[] = [5, 10, 30, 50, 100];
  total: number = 0;
  followLatentObj: {} = {};
  followStaffList: any[] = [];
  marketStaffList: any[] = [];
  followStatusList: any[] = [
    {
      label: "已跟进",
      value: 1,
    },
    {
      label: "未分配",
      value: 2,
    },
    {
      label: "待跟进",
      value: 3,
    },
  ];
  columnFilter: any[] = [
    {
      key: "name",
      label: "学员姓名",
      active: true,
      sort: false,
      readonly: true,
    },
    {
      key: "mobile",
      label: "学员手机号",
      active: true,
      sort: false,
      readonly: true,
    },
    {
      key: "sex",
      label: "性别",
      active: true,
      sort: false,
    },
    {
      key: "age",
      label: "年龄",
      active: true,
      sort: true,
    },
    {
      key: "allocate_num",
      label: "分配次数",
      active: true,
      sort: true,
    },
    {
      key: "allocate_time",
      label: "最近分配时间",
      active: true,
      sort: true,
    },
    {
      key: "follow_time",
      label: "最近跟进时间",
      active: true,
      sort: true,
    },
    {
      key: "follow_log_content",
      label: "最近跟进内容",
      active: true,
      sort: false,
    },
    {
      key: "follow_staff_id",
      label: "跟进状态",
      active: true,
      sort: false,
    },
    {
      key: "stage",
      label: "跟进阶段",
      active: true,
      sort: false,
    },
    {
      key: "appear_id",
      label: "出现方式",
      active: true,
      sort: false,
    },
    {
      key: "student_source",
      label: "来源渠道",
      active: true,
      sort: false,
    },
    {
      key: "intent",
      label: "用户意向",
      active: true,
      sort: false,
    },
    {
      key: "student_subject",
      label: "意向科目",
      active: true,
      sort: false,
    },
    {
      key: "market_staff",
      label: "市场顾问",
      active: true,
      sort: false,
    },
    {
      key: "last_follow_staff",
      label: "最近跟进课程顾问",
      active: true,
      sort: false,
    },
    {
      key: "create_staff",
      label: "创建人",
      active: true,
      sort: false,
    },
    {
      key: "create_time",
      label: "创建时间",
      active: true,
      sort: true,
    },
  ];
  columnFilterCopy: any[] = [
    {
      key: "name",
      label: "学员姓名",
      active: true,
      sort: false,
      readonly: true,
    },
    {
      key: "mobile",
      label: "学员手机号",
      active: true,
      sort: false,
      readonly: true,
    },
    {
      key: "sex",
      label: "性别",
      active: true,
      sort: false,
    },
    {
      key: "age",
      label: "年龄",
      active: true,
      sort: true,
    },
    {
      key: "allocate_num",
      label: "分配次数",
      active: true,
      sort: true,
    },
    {
      key: "allocate_time",
      label: "最近分配时间",
      active: true,
      sort: true,
    },
    {
      key: "follow_time",
      label: "最近跟进时间",
      active: true,
      sort: true,
    },
    {
      key: "follow_log_content",
      label: "最近跟进内容",
      active: true,
      sort: false,
    },
    {
      key: "follow_staff_id",
      label: "跟进状态",
      active: true,
      sort: false,
    },
    {
      key: "stage",
      label: "跟进阶段",
      active: true,
      sort: false,
    },
    {
      key: "appear_id",
      label: "出现方式",
      active: true,
      sort: false,
    },
    {
      key: "student_source",
      label: "来源渠道",
      active: true,
      sort: false,
    },
    {
      key: "intent",
      label: "用户意向",
      active: true,
      sort: false,
    },
    {
      key: "student_subject",
      label: "意向科目",
      active: true,
      sort: false,
    },
    {
      key: "market_staff",
      label: "市场顾问",
      active: true,
      sort: false,
    },
    {
      key: "last_follow_staff",
      label: "最近跟进课程顾问",
      active: true,
      sort: false,
    },
    {
      key: "create_staff",
      label: "创建人",
      active: true,
      sort: false,
    },
    {
      key: "create_time",
      label: "创建时间",
      active: true,
      sort: true,
    },
  ];
  filterDialogVisible = false;
  get canMultiEdit() {
    return UserModule.userInfo.student_intention_claim_switch === 1;
  }
  get activeColumn() {
    return this.columnFilter.filter((item) => {
      return item.active;
    });
  }
  studentAppearLabelList: any[] = [];
  created() {
    eventBus.$on("latent-list-update-waiting", () => {
      const table: any = this.$refs["main-table"];
      table.clearSelection();
      this.handleRefresh();
    });
    let filterCache = localStorage.getItem(
      "ts-latent-waiting-data-filter-params"
    );
    if (filterCache) {
      let json = JSON.parse(filterCache);
      this.columnFilter = [...json.filter];
      this.columnFilterCopy = [...json.copy];
    }
    if (PageModule.latestRoute === "studyDetails") {
      const cache = PageModule.pageInfo.recruitWaitingList;
      if (cache.page) {
        this.page = cache.page;
      }
      if (cache.page_size) {
        this.pageSize = cache.page_size;
      }
      if (cache.search_info) {
        this.searchInfo = cache.search_info;
      }
      this.getList({
        page: cache.page,
        page_size: cache.page_size,
      });
    } else {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    }
    getStudentAppearListApi({
      page: 1,
      page_size: 500,
    }).then((res) => {
      this.studentAppearLabelList = res.data.list;
    });
    getFollowLatentApi().then((res: any) => {
      const obj: any = {};
      res.data.list.map((item: any) => {
        obj[item.key] = item.value;
      });
      this.followLatentObj = obj;
    });
    this.handleChangeFollowStaff("");
    this.getMarketStaffList("");
  }
  handleAppear(scope: any) {
    let target = this.studentAppearLabelList.find((item: any) => {
      return scope.row.appear_id === item.id;
    });
    if (target) {
      return target.name;
    } else {
      return "-";
    }
  }
  handleChangeFollowStaff(v: string) {
    staffList({
      page: 1,
      page_size: 50,
      key_word: v,
      job_ids: [3],
    }).then((res) => {
      this.followStaffList = res.data.list;
    });
  }
  getMarketStaffList(v?: any) {
    getMarketStaffListApi({
      page: 1,
      page_size: 100,
      keyword: v,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.marketStaffList = res.data.list;
      }
    });
  }
  handleSearchSource() {
    if (!this.searchInfo.appear_id) {
      return false;
    }
    sourceTypeSelectListApi({ appear_id: this.searchInfo.appear_id }).then(
      (result: any) => {
        this.sourceList = result.data.list;
      }
    );
  }
  resetSearch() {
    this.searchInfo = {
      key_word: "",
      sex: "",
      allocate_num_start: "",
      allocate_num_end: "",
      allocate_time: [],
      follow_time: [],
      appear_id: "",
      source_type: "",
      last_follow_staff_id: "",
      date: [],
      intent_arr: [],
      age_stage: "",
      follow_status: [],
      market_staff_id: "",
      create_staff_id: "",
    };
    this.page = 1;
    this.pageSize = 10;
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  }
  handleSearch() {
    this.getList({
      page: 1,
      page_size: this.pageSize,
    });
  }
  handleRefresh() {
    this.getList({
      page: this.page,
      page_size: this.pageSize,
    });
  }
  solveSearchParams() {
    let option: getWaitingStudentListData = {};
    if (this.searchInfo.key_word) {
      option.key_word = this.searchInfo.key_word;
    }
    if (this.searchInfo.sex !== "") {
      option.sex = this.searchInfo.sex;
    }
    if (this.searchInfo.allocate_num_start !== "") {
      option.allocate_num_start = this.searchInfo.allocate_num_start;
    }
    if (this.searchInfo.allocate_num_end !== "") {
      option.allocate_num_end = this.searchInfo.allocate_num_end;
    }
    if (
      this.searchInfo.allocate_time &&
      this.searchInfo.allocate_time.length === 2
    ) {
      option.allocate_start_time = this.searchInfo.allocate_time[0];
      option.allocate_end_time = this.searchInfo.allocate_time[1];
    }
    if (
      this.searchInfo.follow_time &&
      this.searchInfo.follow_time.length === 2
    ) {
      option.follow_start_time = this.searchInfo.follow_time[0];
      option.follow_end_time = this.searchInfo.follow_time[1];
    }
    if (this.searchInfo.appear_id !== "") {
      option.appear_id = this.searchInfo.appear_id;
    }
    if (this.searchInfo.source_type !== "") {
      option.source_type = this.searchInfo.source_type;
    }
    if (this.searchInfo.last_follow_staff_id !== "") {
      option.last_follow_staff_id = this.searchInfo.last_follow_staff_id;
    }
    if (this.searchInfo.date && this.searchInfo.date.length === 2) {
      option.start_time = this.searchInfo.date[0].getTime() / 1000;
      option.end_time =
        this.searchInfo.date[1].getTime() / 1000 + (24 * 60 * 60 - 1);
    }
    if (this.searchInfo.intent_arr.length > 0) {
      option.intent_arr = this.searchInfo.intent_arr;
    }
    if (this.searchInfo.age_stage !== "") {
      option.age_stage = this.searchInfo.age_stage;
    }
    if (this.searchInfo.follow_status.length > 0) {
      option.follow_status = this.searchInfo.follow_status;
    }
    if (this.searchInfo.market_staff_id !== "") {
      option.market_staff_id = this.searchInfo.market_staff_id;
    }
    if (this.searchInfo.create_staff_id !== "") {
      option.create_staff_id = this.searchInfo.create_staff_id;
    }
    return option;
  }
  handleExport() {
    let option = this.solveSearchParams();
    exportWaitingStudentListApi(option).then((res) => {
      exportLoop(res.data.task_id);
    });
  }
  getList(params: { page: number; page_size: number }) {
    const option: getWaitingStudentListData = {
      page: params.page,
      page_size: params.page_size,
      ...this.solveSearchParams(),
    };
    if (this.searchInfo.sort_type !== "" && this.searchInfo.sort_field !== "") {
      option.sort_type = this.searchInfo.sort_type;
      option.sort_field = this.searchInfo.sort_field;
    }
    getWaitingStudentListApi(option).then((res: any) => {
      res.data.list = res.data.list || [];
      this.page = res.data.page;
      this.total = res.data.total;
      const today = new Date().getTime();
      res.data.list.map((item: any) => {
        if (item.follow_log) {
          item.follow_log_content = item.follow_log.content || "-";
        } else {
          item.follow_log_content = "-";
        }
        if (item.create_time) {
          item.create_time = dateFormat("YYYY-mm-dd", item.create_time * 1000);
        } else {
          item.create_time = "-";
        }
        if (item.allocate_time) {
          item.allocate_time = dateFormat(
            "YYYY-mm-dd",
            item.allocate_time * 1000
          );
        } else {
          item.allocate_time = "-";
        }
        if (item.follow_time) {
          item.follow_time = dateFormat("YYYY-mm-dd", item.follow_time * 1000);
        } else {
          item.follow_time = "-";
        }
        if (item.age === 0) {
          if (item.birthday !== 0) {
            const severalMonths = today - item.birthday * 1000;
            item.age = new Date(severalMonths).getMonth() + "个月";
          } else {
            item.age = "-";
          }
        } else {
          item.age = item.age + "岁";
        }
      });
      this.tableData = res.data.list;
      if (res.data.page > 1 && res.data.list.length === 0) {
        this.handleSearch();
      }
      this.savePageInfo();
    });
  }
  handleSelectionChange(arr: any[]) {
    this.multipleSelection = arr;
  }
  handlePagerChange(e: number) {
    this.getList({
      page: e,
      page_size: this.pageSize,
    });
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getList({
      page: 1,
      page_size: e,
    });
  }
  toStudentDetail(row: any) {
    this.$router.push({
      name: "studyDetails",
      query: { id: row.student_id, tab: "followup", from: "waiting_student" },
    });
  }
  savePageInfo() {
    PageModule.SET_PAGE_INFO({
      name: "recruitWaitingList",
      key: "page",
      value: this.page,
    });
    PageModule.SET_PAGE_INFO({
      name: "recruitWaitingList",
      key: "page_size",
      value: this.pageSize,
    });
    PageModule.SET_PAGE_INFO({
      name: "recruitWaitingList",
      key: "search_info",
      value: this.searchInfo,
    });
  }
  beforeDestroy() {
    eventBus.$off("latent-list-update-waiting");
  }
  showFilterDialog() {
    this.columnFilter.map((item, index) => {
      this.columnFilterCopy[index]
        ? (this.columnFilterCopy[index].active = item.active)
        : "";
    });
    this.filterDialogVisible = true;
  }
  handleFilterDialogCancel() {
    this.filterDialogVisible = false;
  }
  handleFilterDialogSubmit() {
    let activeList = this.columnFilterCopy.filter((item) => {
      return item.active;
    });
    if (activeList.length === 0) {
      this.$message({
        message: "请选择列表数据",
        type: "warning",
      });
      return false;
    }
    this.columnFilterCopy.map((item, index) => {
      this.columnFilter[index].active = item.active;
    });
    this.filterDialogVisible = false;
    this.$nextTick(() => {
      let tableEl: any = this.$refs["main-table"];
      tableEl.doLayout();
    });
    // 保存参数
    localStorage.setItem(
      "ts-latent-waiting-data-filter-params",
      JSON.stringify({
        filter: this.columnFilter,
        copy: this.columnFilterCopy,
      })
    );
  }
  handleMultiClaim() {
    let ids = this.multipleSelection.map((s) => {
      return s.id;
    });
    if (!ids || ids.length === 0) {
      return false;
    }
    this.$confirm(
      `确定对选中${ids.length}个学员认领吗？认领后，归属为你的意向学员，负责跟进`,
      `批量认领`,
      {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        type: "warning",
      }
    )
      .then(() => {
        claimWaitingStudentApi({
          student_ids: ids,
        }).then((res) => {
          if (res.data.fail_total > 0) {
            this.$message({
              type: "error",
              message: res.data.fail_message,
            });
          } else {
            this.$message({
              type: "success",
              message: "认领成功",
            });
          }
          this.handleRefresh();
        });
      })
      .catch(() => {});
  }
  clickStort(e: { order: string; prop: string }) {
    this.searchInfo.sort_field = e.prop;
    if (e.order == "descending") {
      this.searchInfo.sort_type = "desc";
    } else if (e.order == "ascending") {
      this.searchInfo.sort_type = "asc";
    } else {
      this.searchInfo.sort_type = "";
    }
    this.handleSearch();
  }
}
